import PropTypes from 'prop-types';
const productShapeV1 = PropTypes.shape({
  id: PropTypes.string,
  icon: PropTypes.string,
  name: PropTypes.string
});
const productShapeV2 = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
  iconUrl: PropTypes.string,
  defaultUrl: PropTypes.string
});
export const productsListShape = PropTypes.arrayOf(PropTypes.oneOfType([productShapeV1, productShapeV2]));
export const projectShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  accountName: PropTypes.string,
  imageUrl: PropTypes.string,
  defaultUrl: PropTypes.string,
  platform: PropTypes.string,
  products: PropTypes.arrayOf(productShapeV2)
});
export const projectsListShape = PropTypes.arrayOf(projectShape);
export const accountShape = PropTypes.shape({
  account_display_name: PropTypes.string.isRequired,
  account_id: PropTypes.string.isRequired,
  account_only_scope: PropTypes.arrayOf(PropTypes.string.isRequired),
  account_scope: PropTypes.arrayOf(PropTypes.string.isRequired),
  account_url: PropTypes.string.isRequired,
  api_access: PropTypes.bool,
  image_url: PropTypes.string.isRequired,
  region: PropTypes.string,
  services: PropTypes.arrayOf(PropTypes.shape({
    account_url: PropTypes.string,
    display_name: PropTypes.string,
    service_access: PropTypes.string,
    service_category: PropTypes.string,
    service_domain: PropTypes.string,
    service_icon: PropTypes.string,
    service_type: PropTypes.string
  }))
});
export const accountsListShape = PropTypes.arrayOf(accountShape);
export const userShape = PropTypes.shape({
  email: PropTypes.string,
  name: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  imageUrl: PropTypes.string,
  oxygenId: PropTypes.string,
  autodeskId: PropTypes.string
});
const manualLicenseDataShape = PropTypes.shape({
  features: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    licenses: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string,
      libraries: PropTypes.arrayOf(PropTypes.shape({
        library: PropTypes.string,
        copyright: PropTypes.string
      }))
    }))
  }))
});
const automaticLicenseDataShape = PropTypes.arrayOf(PropTypes.shape({
  type: PropTypes.string,
  attribution: PropTypes.string,
  licenses: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    version: PropTypes.string,
    repository: PropTypes.string,
    source: PropTypes.string,
    author: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string
    })]),
    license: PropTypes.string,
    licenseText: PropTypes.string
  }))
}));
export const licenseDataShape = PropTypes.oneOfType([automaticLicenseDataShape, manualLicenseDataShape]);
//# sourceMappingURL=propTypes.js.map